export class UIEffectsHelper {
  static scrollToMessage(comp: any, messageId: string | undefined, align: 'start' | 'end' = 'end'): void {
    if (!messageId) {
      comp.scrollToBottom();
      return;
    }

    const targetBlock = comp.chatPreviewBlocks?.find((b: any) => b.messageId === messageId);
    const isTempQuery = targetBlock?.isTemp || false;
    
    let attempts = 0;
    const maxAttempts = 25;
    let lastHeight = 0;
    let heightStableCount = 0;

    const tryScroll = () => {
      const element = document.getElementById('message-' + messageId);
      const container = comp.chatHistoryScroll?.nativeElement;

      if (element && container) {
        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        const currentHeight = elementRect.height;
        const isStable = currentHeight > 10 && Math.abs(currentHeight - lastHeight) < 5;

        if (isStable && (isTempQuery || attempts >= 6)) {
          heightStableCount++;
        } else if (!isStable) {
          heightStableCount = 0;
        }
        lastHeight = currentHeight;

        if (heightStableCount === 3) {
          let targetScrollTop = 0;
          if (align === 'start') {
            targetScrollTop = container.scrollTop + elementRect.top - containerRect.top;
          } else {
            const relativeElementBottom = elementRect.bottom - containerRect.top;
            targetScrollTop = container.scrollTop + relativeElementBottom - containerRect.height + 24;
          }

          container.scrollTo({
            top: targetScrollTop,
            behavior: 'smooth'
          });

          setTimeout(() => {
            comp.isScrollingToTarget = false;
          }, 1000);

          if (!isTempQuery) {
            comp.scrollSpacerHeight = 0;
            comp._loaderService.hideLoader();
            comp.stopAiLoader();
            comp.arktabaccess = false;
          }
          return;
        }
      }

      if (attempts < maxAttempts) {
        attempts++;
        setTimeout(tryScroll, 100);
      } else {
        console.warn('[SCROLL-DEBUG] Timed out waiting for render stabilization. Force scrolling smoothly...');
        comp.isScrollingToTarget = false;
        if (!isTempQuery) {
          comp.scrollSpacerHeight = 0;
          comp._loaderService.hideLoader();
          comp.stopAiLoader();
          comp.arktabaccess = false;
        }
        if (element && container) {
          const containerRect = container.getBoundingClientRect();
          const elementRect = element.getBoundingClientRect();
          let targetScrollTop = 0;
          if (align === 'start') {
            targetScrollTop = container.scrollTop + elementRect.top - containerRect.top;
          } else {
            const relativeElementBottom = elementRect.bottom - containerRect.top;
            targetScrollTop = container.scrollTop + relativeElementBottom - containerRect.height + 24;
          }
          container.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
        } else {
          comp.scrollToBottom();
        }
      }
    };

    setTimeout(tryScroll, 50);
  }

  static onDocumentClick(comp: any, event: Event): void {
    const target = event.target as Node;

    // 1. Handle Exports Popup
    if (comp.isExportspopup) {
      const popupEl = comp.exportsPopupRef && comp.exportsPopupRef.nativeElement as Node;
      if (popupEl && !popupEl.contains(target)) {
        comp.isExportspopup = false;
      }
    }

    const activeExportBlock = comp.chatPreviewBlocks?.find((c: any) => c.isExportspopup);
    if (activeExportBlock) {
      const targetEl = event.target as HTMLElement;
      if (!targetEl.closest('.exports-popup-container')) {
        activeExportBlock.isExportspopup = false;
      }
    }

    // 2. Handle Like Feedback Box
    const activeLikeChat = comp.chatPreviewBlocks?.find((c: any) => c.showLikeInput);
    if (activeLikeChat) {
      const boxEl = comp.likeFeedbackBox && comp.likeFeedbackBox.nativeElement as Node;
      if (boxEl && !boxEl.contains(target)) {
        activeLikeChat.showLikeInput = false;
        activeLikeChat.likeReason = '';
      }
    }

    // 3. Handle Dislike Feedback Box
    const activeDislikeChat = comp.chatPreviewBlocks?.find((c: any) => c.showDislikeInput);
    if (activeDislikeChat) {
      const boxEl = comp.dislikeFeedbackBox && comp.dislikeFeedbackBox.nativeElement as Node;
      if (boxEl && !boxEl.contains(target)) {
        activeDislikeChat.showDislikeInput = false;
        activeDislikeChat.dislikeReason = '';
      }
    }

    // 4. Handle Delete Confirm Box
    const activeDeleteChat = comp.chatPreviewBlocks?.find((c: any) => c.showDeleteConfirm);
    if (activeDeleteChat) {
      const boxEl = comp.deleteConfirmBox && comp.deleteConfirmBox.nativeElement as Node;
      if (boxEl && !boxEl.contains(target)) {
        activeDeleteChat.showDeleteConfirm = false;
      }
    }

    // 5. Handle Chatbot Output Dropdows
    const targetEl = target as HTMLElement;
    let anyDropdownClosed = false;
    comp.chatPreviewBlocks?.forEach((block: any) => {
      const blockEl = targetEl.closest('#message-' + block.messageId);

      if (block.sampleSizeDropdown && (!blockEl || !targetEl.closest('.significanceMainContainer'))) {
        block.sampleSizeDropdown = false;
        anyDropdownClosed = true;
      }
      if (block.confidenceLevelDropDown && (!blockEl || !targetEl.closest('.confidenceLevelMainContainer'))) {
        block.confidenceLevelDropDown = false;
        anyDropdownClosed = true;
      }
      if (block.referenceLevelDropDown && (!blockEl || !targetEl.closest('.ReferenceLevelMainContainer'))) {
        block.referenceLevelDropDown = false;
        anyDropdownClosed = true;
      }
      if (block.dataDropDown && (!blockEl || !targetEl.closest('.dataMainContainer'))) {
        block.dataDropDown = false;
        anyDropdownClosed = true;
      }
      if (block.weightDropDown && (!blockEl || !targetEl.closest('.weightMainContainer'))) {
        block.weightDropDown = false;
        anyDropdownClosed = true;
      }
      if (block.baseDropDown && (!blockEl || !targetEl.closest('.BaseMainContainer'))) {
        block.baseDropDown = false;
        anyDropdownClosed = true;
      }
    });

    if (anyDropdownClosed) {
    }

    // 6. Handle Multi-Question Panel
    if (comp.isMultiQuestionMode) {
      if (!targetEl.closest('.multi-question-panel') && !targetEl.closest('.multi-q-toggle')) {
        comp.isMultiQuestionMode = false;
      }
    }
  }

  static playNotificationSound(comp: any) {
    try {
      const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
      if (!AudioContext) return;
      const audioCtx = new AudioContext();
      const oscillator = audioCtx.createOscillator();
      const gainNode = audioCtx.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioCtx.destination);
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(880, audioCtx.currentTime);
      gainNode.gain.setValueAtTime(0.5, audioCtx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioCtx.currentTime + 0.4);

      oscillator.start(audioCtx.currentTime);
      oscillator.stop(audioCtx.currentTime + 0.4);
    } catch (e) {
      console.warn('Audio playback failed', e);
    }
  }

  static onChatScroll(comp: any, event: Event): void {
    if (comp.isScrollingToTarget) {
      return;
    }

    const container = event.target as HTMLElement;
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const thresholdBuffer = 400;

    comp.chatPreviewBlocks.forEach((block: any, index: number) => {
      if (!block.messageId || block.isTemp || block.fullAnswer || comp.inFlightLazyFetches.has(block.messageId)) {
        return;
      }

      const element = document.getElementById('message-' + block.messageId);
      if (element) {
        const elementRect = element.getBoundingClientRect();
        const isNearVisible = (
          elementRect.bottom >= containerRect.top - thresholdBuffer &&
          elementRect.top <= containerRect.bottom + thresholdBuffer
        );

        if (isNearVisible) {
          comp.lazyFetchBlockAnswer(block);
        }
      }
    });
  }

  static scrollInsights(comp: any, direction: 'up' | 'down', block: any, container: HTMLElement): void {
    if (container) {
      const step = (container.clientHeight * 0.75) || 120;
      const scrollAmount = direction === 'up' ? -step : step;

      container.scrollBy({
        top: scrollAmount,
        behavior: 'smooth'
      });

      setTimeout(() => comp.checkInsightsOverflow(block, container), 600);
    }
  }

  static triggerTabEnabledAnimation(comp: any) {
    if (comp.tabEnableTimeout) {
      return;
    }
    comp.isTabJustEnabled = true;
    comp.tabEnableTimeout = setTimeout(() => {
      comp.isTabJustEnabled = false;
      comp.tabEnableTimeout = null;
    }, 1200);
  }

  static navigateToLanding(comp: any): void {
    if (comp.guidChatId) {
      comp.abandoningSessionId = comp.guidChatId;
      comp.isNewChatStarted = true;
    }
    comp.currentView = 'landing';
    comp.isMultiQuestionMode = false;
    comp.chatPreviewBlocks = [];
    comp.guidChatId = '';
    comp.validatedSessionId = '';
    comp.newChatId = null;
    comp.selectedChatId = null;
    comp.selectedMessageId = null;
    comp.inputValue = '';
    comp.searchText = '';
    comp.isNewChatSession = true;
  }

  static navigateToChat(comp: any): void {
    comp.currentView = 'chat';
    comp.isNewChatSession = false;
    comp.isMultiQuestionMode = false;
  }

  static handleKeyboardEvent(comp: any, event: KeyboardEvent) {
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      if (comp.isSpeechSupported) {
        comp.toggleDictation('main');
      }
    }

    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'b') {
      event.preventDefault();
      comp.toggleMultiQuestionMode();
    }

    if (event.ctrlKey && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      if (!comp.isChatSearchOpen) {
        comp.toggleChatSearch();
      } else {
        const searchInput = document.getElementById('chat-search-input');
        if (searchInput) {
          searchInput.focus();
        }
      }
    }
  }

  static isChartVisible(comp: any, block: any): boolean  {
    if (comp.isSnapshotVisible(block)) return false;

    const anyChartSelected = !!(block.isVerticalGroupBarChartClick ||
      block.isVerticalBarChartClick ||
      block.isVerticalStackChartClick ||
      block.isLineChartClick);

    if (anyChartSelected) return true;
    return comp.getMcode(block) === 1 && block.isChartView !== false && !block.isTableClick;
  }
}
